module.exports = __webpack_public_path__ + "static/media/7.690f1ff0.svg";